module.exports = __webpack_public_path__ + "static/sb_std-4847ecdaa58fba720d7c613e545de2d0.png";